import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

// Above the createApp() line
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { createPinia } from 'pinia';
import client from './plugins/auth';
import { mask } from '@ionited/mask-vue';

import BaseLayout from '@/layouts/BaseLayout.vue'

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);

const app = createApp(App)
  .use(createPinia())
  .use(IonicVue)
  .use(router)
  .directive('mask', mask);

app.use(client);
  
router.isReady().then(() => {
  app.mount('#app');
});

app.component('base-layout', BaseLayout);